<template>
  <div class="main pages-dashboard">
    <div class="container py-4">
      <div class="row no-gutters">
        <div class="col-12 col-lg-4 col-xl-3 mb-3">
          <div class="panel bg-white">
            <div class="panel-heading h2 bg-primary text-white p-3">
              Welcome
            </div>
            <div class="p-3">
              <template v-if="$root.isLoggedIn">
                <h3 class="mb-1">{{ $root.user.name }}</h3>
                <h5 class="text-primary font-weight-bold">
                  {{ $root.company.name }}
                </h5>
                <div class="text-links mb-3">
                  <a
                    :href="
                      route('training.users.show', { user: $root.user.id })
                    "
                    >My Profile</a
                  >
                  <a
                    v-if="!$root.isPublicUser"
                    href="#"
                    @click.prevent="showHoursModal()"
                    >My Total Hours</a
                  >
                  <a
                    v-if="$root.isTrainer"
                    :href="route('profile.calendar.index', {
                      trainer: this.$root.user.id
                    })"
                    >Manage Calendar</a
                  >
                  <a
                    v-if="$root.isManager"
                    :href="route('profile.settings.index')"
                    >Settings</a
                  >
                </div>
                <div class="mb-3">
                  <a
                    class="link-with-icon yellow-link mb-3 ga-event"
                    href="#"
                    @click.prevent="showHelpModal()"
                    title="Access downloadable help resources"
                    data-ga-category="Buttons"
                    data-ga-action="help"
                    data-ga-label="Help"
                  >
                    <span class="icon text-icon">?</span>
                    <span class="text">Need Help?</span>
                  </a>
                  <a
                    class="link-with-icon teal-link mb-3 ga-event"
                    href="#"
                    @click.prevent="showContactModal()"
                    title="Questions or Comments? Send us your feedback"
                    data-ga-category="Buttons"
                    data-ga-action="feedback-form"
                    data-ga-label="Feedback Form"
                  >
                    <icon icon="mail" class="icon" />
                    <span class="text">Contact Us</span>
                  </a>
                  <a
                    v-if="showCourseRequestLink"
                    class="link-with-icon teal-link ga-event"
                    href="#"
                    @click.prevent="showCourseRequestNotice()"
                    data-ga-category="Buttons"
                    data-ga-action="request-a-course"
                    data-ga-label="Request a Course"
                  >
                    <icon icon="courses" class="icon" />
                    <span class="text">
                      Request a
                      <strong>new distributor course</strong> be added to the
                      catalog
                    </span>
                  </a>
                </div>
              </template>
              <template v-else>
                <div class="mb-3 text-center login-container">
                  <p class="mb-2">
                    <strong>Have an HVACpartners account?</strong>
                    <br />Use the button below to log in.
                  </p>
                  <a class="btn btn-info" :href="hvacpLoginUrl">HVACp Login</a>
                  <hr />
                  <p>
                    <strong>Don't utilize HVACpartners?</strong>
                    <br />Use these buttons to log in or create an account
                  </p>
                  <a class="btn btn-info" :href="route('login')">Login</a>
                  <a class="btn btn-success" :href="route('register')"
                    >Create Account</a
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 col-xl-9 mb-3 pl-lg-3">
          <div class="panel bg-white">
            <div class="panel-heading h2 bg-primary text-white p-3">
              {{ announcementTitle }}
            </div>
            <div class="p-3" v-html="announcementContent"></div>
          </div>
        </div>
      </div>
      <template v-if="quicklinks.length > 0">
        <div class="row no-gutters">
          <div
            v-for="(item, i) in quicklinks"
            :key="i"
            class="quicklink mb-3"
            :class="quicklinkColumn"
          >
            <div class="panel bg-white p-3 w-100" @click="goToUrl(item.url)">
              <div class="icon-wrap">
                <icon :icon="item.icon" class="icon" />
              </div>
              <div class="text-wrap">
                <span class="text">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HelpModal from "components/layout/partials/HelpModal";
import ContactModal from "components/layout/partials/ContactModal";
import CourseRequestNotice from "./registration/partials/CourseRequestNotice";

export default {
  components: {
    HelpModal,
    ContactModal,
    CourseRequestNotice,
  },
  props: {
    announcement: { type: Object, default: () => {} },
    quicklinks: { type: Array, default: () => [] },
    toggles: { type: Array, default: () => [] },
    hvacpLoginUrl: { type: String, required: true },
  },
  computed: {
    announcementTitle() {
      return this.announcement ? this.announcement.title : "My Learning Center";
    },
    announcementContent() {
      return this.announcement
        ? this.announcement.content
        : "<p>Welcome to My Learning Center! Click on one of the links below to get started.</p>";
    },
    quicklinkColumn() {
      var classname = "col-12 col-sm-6";
      if (this.quicklinks.length == 3) {
        classname += " col-md-4";
      } else if (this.quicklinks.length == 4) {
        classname += " col-md-3";
      } else if (this.quicklinks.length > 4) {
        classname += " col-md";
      }
      return classname;
    },
    showCourseRequestLink() {
      return this.$root.isManager || this.$root.isAdmin;
    },
  },
  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { user: this.$root.user })
        .then(() => {})
        .catch(() => {});
    },
    showHelpModal() {
      this.$modal(HelpModal)
        .then(() => {})
        .catch(() => {});
    },
    showContactModal() {
      this.$modal(ContactModal)
        .then(() => {})
        .catch(() => {});
    },
    showCourseRequestNotice() {
      this.$modal(CourseRequestNotice)
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
